import React from 'react';

import { injectedComponent } from '@base/core';
import clsx from 'clsx';

export default injectedComponent(
  {
    name: 'UserAvatar',
    components: ['DefaultAvatar'],
    styles: ['avatar'],
  },
  function UserAvatar({
    src,
    initials,
    classes,
    clickHandler,
    components: { DefaultAvatar },
    styles: { avatar: avatarStyles },
  }) {
    return (
      <div className={clsx(avatarStyles.userAvatar, classes)} onClick={clickHandler}>
        <DefaultAvatar initials={initials} />
      </div>
    );
  }
);
